import env from '../shared/utils/env';

function setFont() {
  // 设置网页字体为默认大小
  // @ts-ignore
  WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  // 重写设置网页字体大小的事件
  // @ts-ignore
  WeixinJSBridge.on('menu:setfont', function () {
    // @ts-ignore
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  });
}

function fixIosWeChatInputBug() {
  let myFunction: any;

  let currentPos = 0;

  const focusinCallback = () => {
    clearTimeout(myFunction);
  };

  const focusoutCallback = () => {
    clearTimeout(myFunction);
    currentPos =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    myFunction = setTimeout(() => {
      try {
        window.scrollTo({ top: currentPos + 1, left: 0, behavior: 'smooth' });
      } catch {
        window.scrollTo(0, currentPos + 1);
      }
      currentPos = 0;
    }, 200);
  };

  if (env.isIos && env.isWechat) {
    document.body.addEventListener('focusin', focusinCallback);
    document.body.addEventListener('focusout', focusoutCallback);
  }

  return () => {
    clearTimeout(myFunction);
    document.body.removeEventListener('focusin', focusinCallback);
    document.body.removeEventListener('focusout', focusoutCallback);
  };
}

fixIosWeChatInputBug();

export default () => {
  if (
    // @ts-ignore
    typeof WeixinJSBridge === 'object' &&
    // @ts-ignore
    typeof WeixinJSBridge.invoke === 'function'
  ) {
    setFont();
  } else if (document.addEventListener) {
    // @ts-ignore
    document.addEventListener('WeixinJSBridgeReady', setFont, false);
  }
};
